const SITE_ORIGIN = 'https://agilodonto.com.br';

const PT_MONTHS = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

function formatBlogDate(isoDate) {
  const [year, month, day] = String(isoDate).split('-').map(Number);
  if (!year || !month || !day) return isoDate;
  return `${day} de ${PT_MONTHS[month - 1]} de ${year}`;
}

function absoluteUrl(origin, pathname) {
  const base = String(origin || SITE_ORIGIN).replace(/\/$/, '');
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${base}${path}`;
}

function blogIndexPath() {
  return '/blog';
}

function blogPostPath(slug) {
  return `/blog/${slug}`;
}

function buildBlogIndexMeta(origin = SITE_ORIGIN) {
  return {
    title: 'Blog ÁgilOdonto · Série Especialidades',
    description:
      'Série Especialidades: clínica geral, ortodontia, implantodontia e HOF — o que é cada área, a rotina e os primeiros passos depois da graduação.',
    url: absoluteUrl(origin, blogIndexPath()),
    image: absoluteUrl(origin, '/blog/covers/blog-esp-01-clinica-geral.png'),
  };
}

function buildBlogPostMeta(post, origin = SITE_ORIGIN) {
  return {
    title: `${post.title} · Blog ÁgilOdonto`,
    description: post.description,
    url: absoluteUrl(origin, blogPostPath(post.slug)),
    image: absoluteUrl(origin, post.cover),
  };
}

module.exports = {
  SITE_ORIGIN,
  formatBlogDate,
  absoluteUrl,
  blogIndexPath,
  blogPostPath,
  buildBlogIndexMeta,
  buildBlogPostMeta,
};
